module.exports = __webpack_public_path__ + "static/media/diamon_drink.19c2d8eb.png";